import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import Model, {type Credit} from './model';

export const fetch = (institutionId: string, billPayerId: string) =>
    RESTClient.getAuthenticatedObservable(`v2/invoicing/${institutionId}/${billPayerId}/credits`).map(response => {
        return {
            behaviors: new BehaviorsCollection(response.behaviors),
            credits: response.credits.map(credit => Model.fromAPI(credit)),
        };
    });

export const create = (institutionId: string, billPayerId: string, credit: Credit) =>
    RESTClient.postAuthenticatedObservable(`v2/invoicing/${institutionId}/${billPayerId}/credits`, {
        credit: Model.toAPI(credit),
    }).map(response => Model.fromAPI(response.credit));

export const update = (institutionId: string, credit: Credit) =>
    RESTClient.putAuthenticatedObservable(
        `v2/invoicing/${institutionId}/${credit.billPayerId}/credits/${credit.creditId}`,
        {credit: Model.toAPI(credit)},
    ).map(response => Model.fromAPI(response.credit));

export const remove = (institutionId: string, credit: Credit) =>
    RESTClient.deleteAuthenticatedObservable(
        `v2/invoicing/${institutionId}/${credit.billPayerId}/credits/${credit.creditId}`,
    ).mapTo(credit.creditId);
